<script lang="ts">
  import { Card } from '../../common';
  import { emojiVariant } from '@centerhealth/fe/stores';

  export let flipComponent = false;
</script>

<section class="mt-7">
  <div class="container mx-auto grid grid-cols-12 gap-4 md:grid-rows-1">
    <div class={flipComponent ? 'cards-wrapper-reversed' : 'cards-wrapper'}>
      <div class="grid grid-cols-12">
        <Card customClass="mb-2 col-start-1 col-end-11 order-first" variant="secondary">
          <p class="text-base font-semibold xl:text-lg">⚠️💧 Hypo warning</p>
          <p class="text-gray xl:text-lg">
            Uh-oh! Based on your past history, your stated injection of 5 units for this meal might
            lead to a hypo – keep an eye out!
          </p>
        </Card>
        <Card customClass="mb-2 col-start-3 col-end-13" variant="secondary">
          <p class="text-base font-semibold xl:text-lg">📈💧 Blood sugar trend</p>
          <p class="text-gray xl:text-lg">
            Your blood sugar appears to consistently spike around 6pm on Wednesdays. Maybe you
            should take a look?
          </p>
        </Card>
        <Card customClass="mb-2 col-start-2 col-end-12" variant="secondary">
          <p class="text-base font-semibold xl:text-lg">⏰💉 Basal insulin reminder</p>
          <p class="text-gray text-base xl:text-lg">
            Hey! It's 11pm, here's your reminder to take your 10 units of basal insulin.
          </p>
        </Card>
      </div>
    </div>
    <div class="aria-common {flipComponent ? 'aria-wrapper-reversed' : 'aria-wrapper'}">
      <h2 class="text-center mb-2 md:text-left">
        {$emojiVariant === 'control' ? '🔮' : ''} Introducing your new assistant,
        <span class="font-semibold">Aria</span>
      </h2>
      <p class="text-gray text-base text-center md:text-left xl:text-lg">
        Aria automatically points out trends in your data, helping you better understand, predict,
        and treat your diabetes.
      </p>
    </div>
  </div>
</section>

<style lang="postcss">
  /* col-end number is exclusive  */
  .cards-wrapper {
    @apply col-span-12 md:col-start-7 md:col-end-13 xl:col-start-8 xl:col-end-13;
  }
  .cards-wrapper-reversed {
    @apply col-span-12 md:col-start-1 md:col-end-7 xl:col-start-2 xl:col-end-7;
  }

  /* Common style for aria element both reversed and normal */
  .aria-common {
    @apply col-span-12 mt-5;
    /* md Override */
    @apply md:row-start-1 md:mt-0 md:flex md:flex-col md:justify-center;
  }

  .aria-wrapper {
    @apply md:col-start-1 md:col-end-6;
    /* xl Override */
    @apply xl:col-start-2 xl:col-end-7 xl:pr-4;
  }
  .aria-wrapper-reversed {
    @apply md:col-start-8 md:col-end-13;
    /* xl Override */
    @apply xl:col-start-8 xl:col-end-13 xl:pr-4;
  }
</style>
